'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {CatalogProductListContent} from '@/src/core/domain/entities/catalog'
import {PageData} from '@/src/core/domain/entities/page/page-data'

import {CatalogOptions} from '@/src/features/catalog'

import {useStore} from '@/src/shared/hooks/useStore'

import {CatalogPaginationContainer} from './pagination-container'
import * as UI from './screen.styled'
import {ProductsListContainer} from '@/src/features/catalog/product-list/products-list-container'
import {FiltersCsrContainer} from '@/src/features/catalog/filters-v2'

export const CatalogSaleScreen = observer((props: PageData<CatalogProductListContent>) => {
  const {content} = props
  return <ProductListContainer sort={content.sort} />
})

const ProductListContainer = observer(({sort}: {sort: CatalogProductListContent['sort']}) => {
  const {pageData} = useStore<CatalogProductListContent>()
  const {
    products: {items: products},
  } = pageData!.content

  return (
    <UI.Wrapper data-testid="catalog">
      <UI.ContainerCentered>
        <UI.Container>
          <UI.Side>
            <FiltersCsrContainer />
          </UI.Side>

          <UI.Content>
            {products.length > 0 && (
              <UI.CatalogOptions as={CatalogOptions} sort={sort}>
                <CatalogPaginationContainer />
              </UI.CatalogOptions>
            )}

            <ProductsListContainer products={products} />
            {products.length > 0 && <UI.MobilePagination as={CatalogPaginationContainer} withoutOptions />}
          </UI.Content>
        </UI.Container>
      </UI.ContainerCentered>
    </UI.Wrapper>
  )
})
